import { observable, action, computed } from 'mobx'

export default class DemoStore {
  @observable dataTest = {
    value: 'ninh',
    timeUpdated: 0   
  }
  
  @action updateData(value, timeUpdated) {
    this.dataTest.value = value;  
    this.dataTest.timeUpdated = timeUpdated;
  }

  @action updateDataObject(newDataTest) {
    this.dataTest = newDataTest;     
  }

  @computed get getStringObjectName(){
    return this.dataTest.value + '---' + this.dataTest.timeUpdated
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/DemoStore.js